import { useState, useEffect } from "react";
import useDownloader from "react-use-downloader";
//ui
import { Button, Flex, Text, IconButton, Stack, useToast } from "@chakra-ui/react";
import { ChevronFillIcon, CircleCheckIcon } from "components/icons";
import { usePodcastProvider } from "components/podcast/PodcastProvider";
import { getSingleAudioFile } from "services/utils";

export function DownloadModalContent() {
  const { onClose, modalPodcast } = usePodcastProvider();
  const { download, cancel, percentage } = useDownloader();
  const [outputUrl, setOutputUrl] = useState<string>("");

  const podcastName = modalPodcast?.title.trim().replace(/\s+/g, "-").toLowerCase();
  const filename = modalPodcast?.audio_urls ? `${podcastName}.mp3` : `${podcastName}.mp4`;

  const downloadFile = async () => {
    const fileUrl = outputUrl || "";
    download(fileUrl, filename);
  };

  const toast = useToast();

  const handleGoBackButton = () => {
    onClose();
    cancel();
  };

  useEffect(() => {
    async function getPodcastLinks() {
      try {
        if (modalPodcast?.audio_urls) {
          const audioFileUrl = await getSingleAudioFile(modalPodcast.audio_urls);
          setOutputUrl(audioFileUrl);
        }
      } catch (error) {
        toast({
          status: "error",
          title: "There was an error generating the download file",
          isClosable: true
        });
      }
    }
    getPodcastLinks();
  }, []);

  return (
    <Flex flexDir="column" pt="25px" pb={{ base: "149px", md: "74px" }} color="purple.50" width="100%" alignItems={{ base: "flex-start", md: "center" }} px={{ base: "8px", md: "0px" }}>
      <IconButton
        icon={<ChevronFillIcon width="48px" height="48px" />}
        width="24px"
        aria-label="close-modal"
        bg="transparent"
        borderRadius="24px"
        _hover={{ bg: "transparent" }}
        color="purple.50"
        onClick={onClose}
        display={{ base: "flex", md: "none" }}
      />
      <Flex flexDir="column" width="100%" alignItems="center" px={{ base: "31px", md: "0px" }}>
        <Flex
          justifyContent="center"
          fontWeight="600"
          letterSpacing="-0.02em"
          fontSize={{ base: "24px", md: "32px" }}
          px={{ base: "31px", md: "0px" }}
          lineHeight={{ base: "32px", md: "40px" }}
          maxWidth="650px"
          width="100%"
        >
          <Text textAlign="center" as="h5">
            Download Episode {modalPodcast?.episode_number}
          </Text>
        </Flex>
        <Text as="h5" mt="36px" letterSpacing="-0.01em" fontSize="16px" lineHeight="20px">
          Are you sure you want to download {modalPodcast?.title}?
        </Text>
        <Flex maxWidth="488px" flexDirection={{ base: "column", md: "row" }} width="100%" mt="36px" alignItems="center" justifyContent={{ base: "center", sm: "space-between" }}>
          <Button
            borderRadius="6px"
            alignItems="center"
            spacing="50px"
            bg="purple.100"
            maxWidth="220px"
            width="100%"
            py="12px"
            height="48px"
            px="24px"
            color="#FCFCFC"
            fontSize="16px"
            lineHeight="24px"
            fontWeight="600"
            letterSpacing="0.05em"
            font="sora"
            mb={{ base: "28px", md: "0" }}
            ml={{ md: "20px" }}
            onClick={downloadFile}
            order={{ base: "1", md: "2" }}
          >
            {percentage > 0 ? (
              <Stack direction="row" spacing="4">
                <CircleCheckIcon color="white" height="24px" width="24px" /> <span>Downloading</span>
              </Stack>
            ) : (
              <span>Download File</span>
            )}
          </Button>
          <Button
            borderRadius="6px"
            alignItems="center"
            spacing="50px"
            bg="transparent"
            maxWidth="220px"
            width="100%"
            py="12px"
            height="48px"
            px="24px"
            variant="outline"
            color="purple.100"
            border="2px solid #4D3D8D"
            fontSize="16px"
            lineHeight="24px"
            fontWeight="600"
            letterSpacing="0.05em"
            font="sora"
            _hover={{
              bg: "transparent"
            }}
            onClick={handleGoBackButton}
            order={{ base: "2", md: "1" }}
          >
            Go back
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
